import React from 'react'

export default function TabGeneral({ title, setTitle, description, setDescription, domain, setDomain, domainList, t }) {
  return (
    <React.Fragment>
      <div className="widget-form-field">
        <label>{t('widget.fieldTitle') || 'Nimi (sisäinen)'}</label>
        <input type="text" value={title} onChange={e => setTitle(e.target.value)} />
      </div>
      <div className="widget-form-field">
        <label>{t('widget.fieldDescription') || 'Sisäinen kuvaus'}</label>
        <textarea value={description} onChange={e => setDescription(e.target.value)} rows={2} />
      </div>
      <div className="widget-form-field">
        <label>{t('widget.fieldDomain') || 'Domain'} *</label>
        <input type="text" value={domain} onChange={e => setDomain(e.target.value)} placeholder="example.com" />
        {/* Required: an empty list would make the widget embeddable on any site. */}
        {domainList.length === 0 ? (
          <span className="passcode-error">
            {t('widget.fieldDomainRequired') || 'Anna vähintään yksi domain'}
          </span>
        ) : (
          <span className="form-hint">
            {t('widget.fieldDomainHint') || 'The widget will only work on these domains. Separate multiple domains with a comma.'}
          </span>
        )}
      </div>
    </React.Fragment>
  )
}
